import React, { useEffect, useState } from "react";
import { ButtonSizeOptions } from "@loanbossinc/component-library";

import DocIcon from "../docIcon.svg";

import {
  StyledContainer,
  RoundAvatar,
  IconWrapper,
  StepHeader,
  StepInfo,
  LoansContainer,
  ButtonBar,
  StyledPrimaryButton,
  BackButton,
  CheckboxWrapper,
  StyledInputCheckbox
} from "./styles";

const LoansSelectionStep = props => {
  const {
    allDealLoans,
    selectedLoansForDSCR,
    selectedLoansForDY,
    setDscrSetupSelections,
    setDebtYieldSetupSelections,
    history,
    location,
    dscrReportComponent,
    debtYieldReportComponent,
    componentType,
    match: {
      params: { dealId, reportId }
    }
  } = props;

  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    const dealLoanCheck = allDealLoans && allDealLoans.length;
    const selectedDSCRCheck = selectedLoansForDSCR && selectedLoansForDSCR.length;
    const selectedDYCheck = selectedLoansForDY && selectedLoansForDY.length;
    if (dealLoanCheck && initialLoad && (selectedDSCRCheck || selectedDYCheck)) {
      const component = componentType === "DSCR" || componentType === "DscrProjected" ? dscrReportComponent : debtYieldReportComponent;
      // if no line item is selected for at least one loan, then we should display loan selection screen
      if (component && component.calculations?.selectedLoans.some((loan) => loan.lineItem)) {
        navigateToDscrCalculations();
      }
    }
  }, [allDealLoans, selectedLoansForDSCR, selectedLoansForDY, componentType]);

  const LoanSelector = ({ loan, isLast }) => {
    let actionType;
    let selectedLoans;
    let propertyToUpdate;
    if (componentType === "DSCR" || componentType === "DscrProjected") {
      actionType = setDscrSetupSelections;
      selectedLoans = selectedLoansForDSCR;
      propertyToUpdate = "selectedLoansForDSCR";
    } else {
      actionType = setDebtYieldSetupSelections;
      selectedLoans = selectedLoansForDY;
      propertyToUpdate = "selectedLoansForDY";
    }
    const isSelected = Boolean(selectedLoans.find(l => l.id === loan.id));
    const handleChange = e => {
      if (e.target.checked) {
        setInitialLoad(false);
        const loanToAdd = allDealLoans.find(l => l.id === loan.id);
        actionType({ [propertyToUpdate]: [...selectedLoans, loanToAdd] });
      } else {
        const filteredLoans = selectedLoans.filter(l => l.id !== loan.id);
        actionType({ [propertyToUpdate]: filteredLoans });
      }
    };

    return (
      <CheckboxWrapper last={isLast}>
        <StyledInputCheckbox label={loan.name.split("-").join(" ")} labelPlacement="end" name="name" onChange={handleChange} value={isSelected} />
      </CheckboxWrapper>
    );
  };

  const getLink = (cType, dscrId, debtYieldId) => {
    switch (cType){
      case "DSCR":
        return `/deal/${dealId}/lender-reports/${reportId}/dscr-calculation/${dscrId}`;
      case "DebtYield":
        return `/deal/${dealId}/lender-reports/${reportId}/debt-yield-calculation/${debtYieldId}`;
      case "DscrProjected":
        return `/deal/${dealId}/lender-reports/${reportId}/projected-dscr-calculation/${debtYieldId}`;
      case "DyProjected":
        return `/deal/${dealId}/lender-reports/${reportId}/projected-debt-yield-calculation/${debtYieldId}`;
      default:
        return `/deal/${dealId}/lender-reports`;
    }
  };
  const navigateToDscrCalculations = () => {
    // need to make seperate dscrReportComponent for regular and projected
    const dscrId = dscrReportComponent ? dscrReportComponent.id : "new";
    const debtYieldId = debtYieldReportComponent ? debtYieldReportComponent.id : "new";
    const link = getLink(componentType, dscrId, debtYieldId);
    history.push(link, { from: props.location.state?.from });
  };

  const handleGoBack = () => {
    if (location.state?.from === "report-wizard") {
      history.push(`/deal/${dealId}/lender-reports-setup/${reportId}`, { from: "undefined-1" });
    } else {
      history.push(`/deal/${dealId}/lender-reports/${reportId}`);
    }
  };

  return (
    <StyledContainer>
      <RoundAvatar>
        <IconWrapper>
          <img src={DocIcon} alt="Doc Logo" />
        </IconWrapper>
      </RoundAvatar>
      <StepHeader>{componentType === "DSCR" ? "Debt Service for DSCR" : "Loan Balance for Debt Yield"}</StepHeader>
      <StepInfo>Please select the loans to be included in calculations:</StepInfo>
      <LoansContainer>
        {allDealLoans &&
          allDealLoans.length &&
          allDealLoans.map((loan, idx) => <LoanSelector loan={loan} key={loan.id} isLast={idx === allDealLoans.length - 1} />)}
      </LoansContainer>
      <ButtonBar>
        <BackButton
          onClick={handleGoBack}
          id="back-button"
          label={location.state?.from === "report-wizard" ? "Calculations" : "Report dashboard"}
          iconName="arrow_forward"
          reverse
          alignRight={false}
          key={1}
        />
        <StyledPrimaryButton
          onClick={navigateToDscrCalculations}
          size={ButtonSizeOptions.sm}
          label="Next"
          disabled={componentType === "DSCR" || componentType === "DscrProjected" ? !selectedLoansForDSCR?.length : !selectedLoansForDY?.length}
        />
      </ButtonBar>
    </StyledContainer>
  );
};

export default LoansSelectionStep;
